export default "__VITE_ASSET__34QV7DmK__"